import eimg1 from '../images/event/img-1.jpg'
import eimg2 from '../images/event/img-2.jpg'
import eimg3 from '../images/event/img-3.jpg'

import eSimg1 from '../images/event/single/img-1.jpg'
import eSimg2 from '../images/event/single/img-2.jpg'
import eSimg3 from '../images/event/single/img-3.jpg'



const Events = [
    {
       Id:'1',
       eImg:eimg1,
       eSimg:eSimg1,
       thumb:'Technology & Digital Skills',   
       title:'Digital Transformation Summit 2025',  
       slug:'Digital-Transformation-Summit-2025',
       month:'15-18',
       date:'Nov',
       time:'09:00 - 17:00',
       duration:'4 Days',
       location:'Manchester, UK',
       progress:'90',
       raised:'2000.00',
       goal:'3000.00',
    },
    {
       Id:'2',
       eImg:eimg2,
       eSimg:eSimg2,
       thumb:'Health & Wellbeing',    
       title:'Health & Wellness Masterclass', 
       slug:'Health-Wellness-Masterclass',
       month:'22-23',
       date:'Nov',
       time:'10:00 - 16:00',
       duration:'2 Days',
       location:'Manchester, UK',
       progress:'80',
       raised:'3000.00',
       goal:'4000.00',
    },
    {
      Id:'3',
      eImg:eimg3,
      eSimg:eSimg3,
      thumb:'Finance & Economy',   
      title:'Financial Planning & Investment Workshop',  
      slug:'Financial-Planning-Investment-Workshop',
      month:'28-30',
      date:'Nov',
      time:'13:00 - 18:00',
      duration:'3 Days',
      location:'Manchester, UK',
      progress:'95',
      raised:'4000.00',
      goal:'5000.00',
   },
   {
      Id:'4',
      eImg:eimg1,
      eSimg:eSimg1,
      thumb:'Business & Entrepreneurship',   
      title:'Startup & Entrepreneurship Conference',  
      slug:'Startup-Entrepreneurship-Conference',
      month:'05-06',
      date:'Dec',
      time:'09:00 - 17:00',
      duration:'2 Days',
      location:'Manchester, UK',
      progress:'85',
      raised:'2500.00',
      goal:'3500.00',
   },
   {
      Id:'5',
      eImg:eimg2,
      eSimg:eSimg2,
      thumb:'Leadership & Personal Development',   
      title:'Leadership Excellence Forum',  
      slug:'Leadership-Excellence-Forum',
      month:'12-15',
      date:'Dec',
      time:'10:00 - 16:00',
      duration:'4 Days',
      location:'Manchester, UK',
      progress:'92',
      raised:'3200.00',
      goal:'4000.00',
   },
   {
      Id:'6',
      eImg:eimg3,
      eSimg:eSimg3,
      thumb:'Environment and Sustainability',   
      title:'Sustainability & Green Future Summit',  
      slug:'Sustainability-Green-Future-Summit',
      month:'18-20',
      date:'Dec',
      time:'09:00 - 15:00',
      duration:'3 Days',
      location:'Manchester, UK',
      progress:'88',
      raised:'2800.00',
      goal:'3800.00',
   },
   {
      Id:'7',
      eImg:eimg1,
      eSimg:eSimg1,
      thumb:'Environment and Sustainability',
      title:'Environment and Sustainability Training',
      slug:'Environment-and-Sustainability-Professional-Training',
      month:'15-19',
      date:'Dec',
      time:'09:00 - 17:00',
      duration:'5 Days',
      location:'Manchester, UK',
      progress:'0',
      raised:'0.00',
      goal:'0.00',
   },
   {
      Id:'8',
      eImg:eimg2,
      eSimg:eSimg2,
      thumb:'Food & Culinary Skills',
      title:'Food & Culinary Skills Training',
      slug:'Food-Culinary-Skills-Training',
      month:'17-23',
      date:'Dec',
      time:'09:00 - 17:00',
      duration:'7 Days',
      location:'Manchester, UK',
      progress:'0',
      raised:'0.00',
      goal:'0.00',
   }
   ,
   {
      Id:'9',
      eImg:eimg3,
      eSimg:eSimg3,
      thumb:'Food & Culinary Skills',
      title:'Food & Culinary Skills Training',
      slug:'Food-Culinary-Skills-Professional-Training',
      month:'05-19',
      date:'Dec',
      time:'09:00 - 17:00',
      duration:'15 Days',
      location:'Manchester, UK',
      progress:'0',
      raised:'0.00',
      goal:'0.00',
   }
    
]

export default Events;